<script>
  import { footer } from "./../content/data.json";
  import Text from "./Text.svelte";
</script>

<footer>
  <div class="c">
    <Text text="{footer}" />
  </div>
</footer>

<style>
  footer {
    background: var(--light-gray);
    padding: 6em 3em;
    /* margin: 10rem 0 0; */
    font-size: 0.8em;
    line-height: 1.6em;
  }
  .c {
    max-width: 60em;
    margin: auto;
  }
  @media (max-width: 800px) {
    footer {
      padding: 6em 2em;
      font-size: 0.9em;
    }
  }
</style>
